// extracted by mini-css-extract-plugin
export var center = "_1h-2";
export var clickableRow = "_1h-5";
export var expandedRow = "_1h-7";
export var hoverable = "_1h-4";
export var left = "_1h-1";
export var right = "_1h-3";
export var row = "_1h-0";
export var selectedRow = "_1h-6";
export var summaryRow = "_1h-8";